import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useScriptMode } from "../../contexts/ScriptModeContext";
import { useGetMyHatimInstancesQuery } from "../../api/hatimApi";
import HatimCard from "./components/HatimCard";
import HatimCardSkeleton from "./components/HatimCardSkeleton";
import HatimListEmpty from "./components/HatimListEmpty";
import HatimMonthPicker from "./components/HatimMonthPicker";
import UpdateHatimProgressModal from "./components/UpdateHatimProgressModal";
import JoinHatimByCodeModal from "./components/JoinHatimByCodeModal";
import { SoftButton, SoftFooter, cls } from "./soft/SoftKit";
import ConnectionState from "../../components/ui/ConnectionState";

function pad(n) { return String(n).padStart(2, "0"); }
function currentMonthKey() {
  const d = new Date();
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
}

/**
 * Hatimlerim: mobildeki yumuşak düzen. Üstte sabit açık şerit (ay seçimi),
 * altında çizgiyle ayrılmış hatim satırları kayar; altta sabit bölgede
 * "Kodla katıl" ve hatim yönetimine geçiş.
 */
export default function HatimPage() {
  const { t } = useScriptMode();
  const navigate = useNavigate();
  const [monthKey, setMonthKey] = useState(currentMonthKey());
  const [editing, setEditing] = useState(null);
  const [joinByCodeOpen, setJoinByCodeOpen] = useState(false);

  const { data, isLoading, isFetching, isError, error, refetch } = useGetMyHatimInstancesQuery({ monthKey });
  const instances = data?.data?.instances || [];

  return (
    <div className="max-w-4xl mx-auto w-full px-4 md:px-0">
      <div className={`${cls.panel} overflow-hidden flex flex-col max-h-[calc(100vh-3rem)] min-h-[360px]`}>
        <div className={`shrink-0 px-4 py-3 flex flex-col gap-3 ${cls.summary}`}>
          <h1 className={`text-2xl font-SemiBold ${cls.heading}`}>{t("hatim_title")}</h1>
          <HatimMonthPicker value={monthKey} onChange={setMonthKey} />
        </div>

        <div className="flex-1 min-h-0 overflow-y-auto">
          {isLoading || isFetching ? (
            <ul>
              <HatimCardSkeleton />
              <HatimCardSkeleton />
              <HatimCardSkeleton />
            </ul>
          ) : isError ? (
            <ConnectionState
              error={error}
              onRetry={refetch}
              retrying={isFetching}
              message={t("hatim_load_error")}
            />
          ) : instances.length === 0 ? (
            <HatimListEmpty />
          ) : (
            <ul>
              {instances.map((inst) => (
                <HatimCard key={inst.id} instance={inst} onUpdate={(i) => setEditing(i)} />
              ))}
            </ul>
          )}
        </div>

        <SoftFooter>
          <SoftButton tone="primary" onClick={() => setJoinByCodeOpen(true)} sx={{ flex: 1 }}>
            {t("hatim_join_code_cta")}
          </SoftButton>
          <SoftButton tone="soft" onClick={() => navigate("/uygulama/hatim-yonetim")}>
            {t("hatim_mgmt_link")}
          </SoftButton>
        </SoftFooter>
      </div>

      <UpdateHatimProgressModal
        open={!!editing}
        instance={editing}
        onClose={() => setEditing(null)}
      />
      <JoinHatimByCodeModal
        open={joinByCodeOpen}
        onClose={() => setJoinByCodeOpen(false)}
      />
    </div>
  );
}
